import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {OnAccountChanged, OnLoggedOut} from "core/redux/auth/AuthReduxActions";
import {SortTrades, SortTradesPayload} from "core/redux/trades/TradesReduxActions";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import TradesEngine, {SortDeals} from "core/engine/TradesEngine";
import {ClosedTradesReduxState} from "core/redux/trades/ClosedTradesReduxState";
import {
    SetClosedTrades,
    SetClosedTradesPayload,
    SetClosedTradesPending, SetClosedTradesPendingPayload
} from "core/redux/trades/ClosedTradesReduxActions";
import {SetPortfolioTabType} from "core/redux/portfolio/PortfolioReduxActions";
import {SetPortfolioDateFilterType} from "core/redux/filter/FilterReduxActions";
import Utils from "platform/util/Utils";
import {PortfolioType} from "enum/PortfolioType";

const initialState = (): ClosedTradesReduxState => {
    return {
        ClosedTrades: []
    };
};

export default class ClosedTradesReducer extends Reducer<ClosedTradesReduxState> {

    private static _instance: ClosedTradesReducer;

    public static instance(): ClosedTradesReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const tradesEngine: TradesEngine = Platform.engine(ServiceType.Trades);
        this._middlewareActions.set(SetPortfolioTabType, tradesEngine.onSetPortfolioTab);
        this._middlewareActions.set(SetPortfolioDateFilterType, tradesEngine.onSetPortfolioDateFilter);
    }

    public get name(): string {
        return "closedTrades";
    }

    protected setup(builder: ReducerBuilder<ClosedTradesReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: ClosedTradesReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(OnAccountChanged, (state: ClosedTradesReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(SetClosedTrades, (state: ClosedTradesReduxState, {payload}: Action<SetClosedTradesPayload>) => {
                this._logger.debug("Set closed trades. Empty " + Utils.isArrayEmpty(payload.ClosedTrades));
                return Object.assign({}, state, {
                    ClosedTrades: payload.ClosedTrades
                });
            })
            .handle(SortTrades, (state: ClosedTradesReduxState, {payload}: Action<SortTradesPayload>) => {
                if (payload.portfolioType === PortfolioType.ClosedTrades) {
                    return Object.assign({}, state, {
                        ClosedTrades: [...state.ClosedTrades].sort(SortDeals(payload.column, payload.sortDirection))
                    });
                }
                return state;
            })
            .handle(SetClosedTradesPending, (state: ClosedTradesReduxState, {payload}: Action<SetClosedTradesPendingPayload>) => {
                return Object.assign({}, state, {
                    closedTradesPending: payload.pending
                });
            });
    }
}
